import { render, staticRenderFns } from "./alipayEmployeeConfig.vue?vue&type=template&id=28cbff7a&"
import script from "./alipayEmployeeConfig.vue?vue&type=script&lang=js&"
export * from "./alipayEmployeeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports